import React from "react";
import Layout from "../Layout/Layout";
const about = () => {
	return(
	    <>
		   About Us
		
		</>
	
	
	
	);
}
export default about;